/**
 * 业务相关
 */

import { JSCallAPP } from "@/utils/interactive";
import { Ref, ref } from "@vue/composition-api";
import { useOnEditorClaim, useOnSetQuickSearchVisible } from "./useAPPCallJS";
import { Dialog } from "vant";
import { DRAW_MODEL } from "@/constants/drawModel";
import { useDrawStore } from "@/store/draw";
import { goBack } from "@/utils/goBack";
import { eventHub } from "@/utils/eventHub";

/**
 * 快速找地
 */
export const useQuickSearch = () => {
  const isShowQuickSearch = ref(false);

  useOnSetQuickSearchVisible((info: boolean) => {
    isShowQuickSearch.value = info;
  });

  const handleQuickSearch = () => {
    JSCallAPP({
      method: "quick_search_land",
    });
  };

  return {
    isShowQuickSearch,
    handleQuickSearch,
  };
};

/**
 * 回退
 * @param hasHistory
 * @returns
 */
export const useBack = () => {
  const store = useDrawStore();

  // 回退
  const handleBack = () => {
    if (store.hasHistory) {
      Dialog.confirm({
        title: "提示",
        className: "ddd-dialog-confirm",
        message: "您有地块尚未保存，确定要离开吗？",
      })
        .then(() => {
          goBack();
        })
        .catch(() => {
          // on cancel
        });
    } else {
      goBack();
    }
  };
  return {
    handleBack,
  };
};

/** 认领土地 */
export const useClaimLand = () => {
  const store = useDrawStore();
  const isShowClaimTip = ref(false);
  const claimHasPathCount = ref(0);
  const claimNotHasPathCount = ref(0);

  useOnEditorClaim((info) => {
    store.isClaim = true;
    store.drawModel = DRAW_MODEL.update;

    isShowClaimTip.value = true;
    claimHasPathCount.value = info.hasPathCount;
    claimNotHasPathCount.value = info.notHasPathCount;

    store.initGraphicInfoList = info.list;

    eventHub.$emit("rerender-map");
  });

  const handleClaimTip = () => {
    Dialog({
      message: "由于缺少该土地经纬度信息，暂无法自动绘制该地块轮廓喔~",
      confirmButtonText: "知道了",
      confirmButtonColor: "#0097ff",
    }).then(() => {
      isShowClaimTip.value = false;
    });
  };

  return {
    isShowClaimTip,
    claimHasPathCount,
    claimNotHasPathCount,
    handleClaimTip,
  };
};
